import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../state/AuthContext';

/**
 * Gate for `/admin/*`. Redirects to /sign-in (which carries the original
 * destination) when the Google session does not have League HQ access.
 */
export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { authReady, canAdmin } = useAuth();
  const location = useLocation();
  if (!authReady) return null;
  if (!canAdmin) {
    return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
